import React from "react";

function LockIcon() {
  return (
    <span className="anticon anticon-lock">

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 13 16"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="square"
          strokeWidth="1.3"
          transform="translate(1 1)"
        >
          <path d="M0 6.222h10.889V14H0zM5.444 0h0a3.89 3.89 0 013.89 3.889v2.333H1.555V3.89A3.889 3.889 0 015.444 0z"></path>
          <circle cx="5.444" cy="10.111" r="1"></circle>
        </g>
      </svg>
    </span>
  );
}

export default LockIcon;
